import React from 'react';
import {
  FaMicrochip,
  FaWrench,
  FaBullhorn,
  FaMagic,
  FaTrophy,
  FaUserFriends,
} from 'react-icons/fa';
import './Advantage.css';

const FEATURES = [
  {
    icon: FaMicrochip,
    title: 'End-to-End IT Solutions',
    desc: 'From discovery to delivery — full-stack engineering at scale.',
  },
  {
    icon: FaWrench,
    title: 'Mechanical Design & Automation',
    desc: 'CAD, PLM and industrial automation that ships.',
  },
  {
    icon: FaBullhorn,
    title: 'Digital Marketing Expertise',
    desc: 'Performance, creative and brand storytelling.',
  },
  {
    icon: FaMagic,
    title: 'Industry-Aligned Strategies',
    desc: 'Playbooks built for your vertical, not generic.',
  },
  {
    icon: FaTrophy,
    title: 'Proven Project Experience',
    desc: '660+ engagements across 13+ years.',
  },
  {
    icon: FaUserFriends,
    title: 'Collaborative Partnerships',
    desc: 'Embedded teams that feel like your own.',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="wcu-section" aria-labelledby="wcu-heading">
      <div className="wcu-container">
       
        <h2 id="wcu-heading" className="wcu-heading">
          The advantage of a <span className="wcu-heading-accent">true partner</span>
        </h2>

        <div className="wcu-grid">
          {FEATURES.map(({ icon: Icon, title, desc }, index) => (
            <div className="wcu-card" key={index}>
              <span className="wcu-icon" aria-hidden="true">
                <Icon />
              </span>
              <h3 className="wcu-card-title">{title}</h3>
              <p className="wcu-card-desc">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;